export const API_CONFIG = {
  BASE_URL: import.meta.env.VITE_AGENT_API_BASE_URL,
  AI_URL: import.meta.env.VITE_AI_URL,
  TIMEOUT: 60000,
  RETRY_ATTEMPTS: 3
};

export const API_ENDPOINTS = {
  AI_JOBS: {
    START: '/api/chat/start',
    MESSAGE: '/api/chat/session'
  },
  COVER_LETTER: {
    START: '/api/cover-letter/start',
    CONTINUE: '/cover-letter/continue'
  },
  INTERVIEW: {
    START: '/api/interview/start',
    CONTINUE: '/api/interview/continue'
  },
  JOB_COACH: {
    START: '/sessions/start',
    MESSAGE: '/sessions/message',
    SESSIONS: '/ai_chat_sessions',
    MESSAGES: '/sessions/messages'
  }
} as const;
